import { Validators } from '@angular/forms'
import { InputType } from '../../../../abacus/enums/input-type.enum'
import { Field } from '../../../../abacus/interfaces/field.interface'
import { EvaluationBy } from '../../../../common/enums/policy-initiative/evaluation-by.enum'
import { InitiativeCategory } from '../../../../common/enums/policy-initiative/initiative-category.enum'
import { IsEvaluated } from '../../../../common/enums/policy-initiative/is-evaluated.enum'
import { PolicyInitiativeCreateEditComponent } from '../policy-initiative-create-edit.component'
import {
  hideIsEvaluatedFields,
  showIsEvaluatedFields
} from './step-2-functions'

export const getStep2Fields = (
  context: PolicyInitiativeCreateEditComponent
): Field[] => {
  const shouldShowEvaluation =
    context.item.category === InitiativeCategory.NationalStrategy

  return [
    {
      label: 'Has this initiative been evaluated?',
      property: 'isEvaluated',
      className: 'is-12',
      placeholder: 'Choose an option...',
      hidden: !shouldShowEvaluation,
      inputType: InputType.Select,
      required: shouldShowEvaluation,
      selectOptions: Object.values(IsEvaluated).map((val) => ({
        label: val,
        value: val
      })),
      onChange: async (value: string) => {
        if (value === IsEvaluated.Yes) {
          const evaluationByField = context.form.get('evaluationBy')
          if (evaluationByField) {
            evaluationByField.setValidators([Validators.required])
            evaluationByField.updateValueAndValidity()
          }
          await showIsEvaluatedFields(context)
        } else {
          await hideIsEvaluatedFields(context)
          const evaluationByField = context.form.get('evaluationBy')
          if (evaluationByField) {
            evaluationByField.clearValidators()
            evaluationByField.updateValueAndValidity()
          }
        }
      }
    },
    {
      id: 'evaluationBy',
      property: 'evaluationBy',
      className: 'is-12',
      label: 'Who was the evaluation performed by?',
      required: false,
      hidden: true,
      inputType: InputType.Select,
      selectOptions: Object.keys(EvaluationBy).map((key) => ({
        label: EvaluationBy[key],
        value: EvaluationBy[key]
      }))
    },
    {
      id: 'isEvaluationResultsPubliclyAvailable',
      property: 'isEvaluationResultsPubliclyAvailable',
      className: 'is-12',
      label: 'Are the evaluation results publicly available?',
      hidden: true,
      inputType: InputType.Checkbox
    },
    {
      id: 'evaluationUrls',
      property: 'evaluationUrls',
      className: 'is-12',
      hidden: true,
      max: 10,
      label: 'Evaluation URL(s)',
      helpText:
        'If there is a page or file relevant to the evaluation (e.g., evaluation report, process, timeline), please add it here.',
      inputType: InputType.MultiText
    },
    {
      id: 'evaluationFiles',
      label: 'Evaluation file(s)',
      property: 'evaluationFiles',
      className: 'is-12',
      hidden: true,
      inputType: InputType.MultiFile,
      askFileYear: false,
      placeholder: 'Choose a file to upload'
    },
    {
      id: 'evaluationDescription',
      label: 'Evaluation description',
      helpText:
        '(e.g., scope, timeframe, findings/conclusion, recommendations)',
      property: 'evaluationDescription',
      className: 'is-12',
      hidden: true,
      max: 1000,
      inputType: InputType.Textarea,
      validators: [Validators.maxLength(1000)],
      placeholder: 'Choose a file to upload'
    }
  ]
}
